import React, { useContext, Fragment } from 'react'
import { TemplateContext } from './TemplateProvider'

import Loading from '../../../../control/loading/Loading'
import AlertMessage from '../../../../control/alert/AlertMessage'

const UtilsPage = () => {
    const { loadingState, alertMessageState } = useContext(TemplateContext)

    return (
        <Fragment>
            <AlertMessage {...alertMessageState.altProps} />
            <Loading isShowLoading={loadingState.isShowLoading} />
        </Fragment>
    )
}

export default UtilsPage
